import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  tableTabAt,
} from "../interfaces";
import { SURQUAL_UH_CAT_PAGE } from "./SURQUAL_UH_CAT";

export const MAPPING_UH_CAT_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  label: "UH_CAT",
  menuLabel: "UH_CAT",
  pageLabel: "UH_CAT_TITLE_MAPPING",
  path: "uh-cats",
  name: "mapping_uh_cat",
  description: "CONF_DESC_MAPPING_UH_CAT",
  model: {
    entityName: "datafeed",
    label: "UH_CAT",
    path: "/api/mapping/uh-cats",
    bulkPath: "/api/mapping/uh-cats/bulk-updates",
    name: "mapping_uh_cat",
    attributes: [
      {
        key: "property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        key: "datafeed",
        order: 2,
        label: "ROOM_TYPE_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 3,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 4,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 5,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 6,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "description",
        order: 7,
        label: "DATA_FEED_DESCRIPTION",
        visible: true,
      },
      {
        key: "uh_cat.short_name",
        order: 8,
        label: "UH_CAT",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/uh-cats/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        lookup: "property",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/mapping/uh-cats/connectors/",
        apiParams: {
          page_size: 100,
          ordering: "connector",
        },
        key: "id",
        labelKey: "id",
        label: "CONNECTOR_CODE",
        lookup: "connector",
        allowEmpty: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/uh-cats/export" },
    import: { path: "/api/mapping/uh-cats/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        key: "datafeed",
        label: "DATA_FEED_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "connector",
        label: "CONNECTOR_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "description",
        label: "DATA_FEED_DESCRIPTION",
      },
      {
        type: ConfigurationFormType.Input,
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          property: {
            path: "property.id",
          },
        },
        key: "uh_cat",
        label: "UH_CAT",
        labelKey: "short_name",
        subCreationForm: tableTabAt(SURQUAL_UH_CAT_PAGE.tabs, 0),
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "property",
        flex: "100%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        readonly: true,
      },
      {
        key: "description",
        flex: "100%",
        readonly: true,
      },
      {
        key: "uh_cat",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "uh_cat",
        flex: "100%",
      },
    ],
  },
};
